import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-link.tsx
var LazyLink = lazy(() => import("./link-TPzUfazB.js").then((n) => n.n).then((module) => ({ default: module.Link })));
function Link({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "link" }),
		children: /* @__PURE__ */ jsx(LazyLink, { ...props })
	});
}
function LinkContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "link" }),
		children: /* @__PURE__ */ jsx(LazyLink, { ...props })
	});
}
var useLinkContent = () => {
	return useMemo(() => ({ link: { component: LinkContent } }), []);
};
//#endregion
export { Link, useLinkContent };
